import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Imprint from '../views/Imprint.vue'
import DataPrivacy from '../views/DataPrivacy.vue'
import Contact from '../views/Contact.vue'
import store from '../store';

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/legal-notice',
    name: 'Imprint',
    component: Imprint
  },
  {
    path: '/data-privacy',
    name: 'DataPrivacy',
    component: DataPrivacy
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/search',
    name: 'Search',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Search.vue')
  },
  {
    path: '/myRequestList',
    name: 'MyRequestList',
    component: () => import('../views/MyRequestList.vue'),
    meta: {
      protected: true
    }
  },
  {
    path: '/requestSetup',
    name: 'RequestSetup',
    component: () => import('../views/RequestSetup.vue'),
    meta: {
      protected: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
})

// redirect unauthorized user from protected pages to Search view
router.beforeEach((to, from, next) => {
  if (to.meta.protected) {
    if (!store.state.user) {
      next({ name: 'Search' });
    } else {
      next();
    }
  } else {
    next();
  }
})
// end

export default router
